import * as React from 'react';
import { cn } from '../../../lib/utils';

export interface ToolbarButtonProps {
    onClick?: () => void;
    isActive?: boolean;
    disabled?: boolean;
    'aria-label': string;
    title?: string;
    children: React.ReactNode;
    className?: string;
}

export const ToolbarButton = React.forwardRef<HTMLButtonElement, ToolbarButtonProps>(
    function ToolbarButton(
        {
            onClick,
            isActive,
            disabled,
            'aria-label': ariaLabel,
            title,
            children,
            className,
        },
        ref
    ) {
        return (
            <button
                ref={ref}
                type="button"
                onClick={onClick ?? undefined}
                disabled={disabled}
                aria-label={ariaLabel}
                title={title}
                className={cn(
                    'rich-text-toolbar-button p-2 rounded-sm transition-colors duration-200',
                    'hover:bg-muted/50 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer',
                    isActive && 'bg-muted/70',
                    className
                )}
            >
                {children}
            </button>
        );
    }
);

ToolbarButton.displayName = 'ToolbarButton';
